import type { FaireProductEntity } from "../../entity_types/product";

export const p_4rbhx4qsg5: FaireProductEntity = {
  token: "p_4rbhx4qsg5",
  type: "product",
  name: "Mushroom Paper Towel Holder Rustic Cast Iron Kitchen Decor",
  brandName: "Iron & Blossom",
  imageUrl:
    "https://cdn.faire.com/fastly/5c5f379bc833fe07bc1f37ca7d49410de58c762f753ef3dc4078a3e0e9d6326f.jpeg",
  priceDollars: 18.55,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/df2bb9a3d6d724ed0d5b18a0513de3c54099c07a1ed3104c37d3acee0f045b37.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
